import { SUPPORTING_DATA_ATTRIBUTES } from '~/common/utils/product/constants'
import { MappedProduct } from '~/types/product/productTypes'
import { mapSupportingDataAttributeToValue } from '~/common/utils/product/product'

export const DATASHEET_PRODUCT_ATTRIBUTES = {
  APPLICATIONS: 'applications',
  SPECIES_CROSS_REACTIVITY: 'speciesCrossReactivity',
  REACTIVITY: SUPPORTING_DATA_ATTRIBUTES.REACTIVITY,
  SENSITIVITY: SUPPORTING_DATA_ATTRIBUTES.SENSITIVITY,
  OBSERVED_MOLECULAR_WEIGHT: SUPPORTING_DATA_ATTRIBUTES.OBSERVED_MOLECULAR_WEIGHT,
  ISOTYPE: SUPPORTING_DATA_ATTRIBUTES.ISOTYPE,
  UNI_PROT_ID: 'uniProdId',
  ENTREZ_GENE_ID: 'entrezGeneId',
  ENTREZ_GENE_ID_HASHTAG: 'entrezGeneId#',
} as const

export type DatasheetProductAttribute = (typeof DATASHEET_PRODUCT_ATTRIBUTES)[keyof typeof DATASHEET_PRODUCT_ATTRIBUTES]

export function getDatasheetProductAttributes(product: MappedProduct, attributes: DatasheetProductAttribute[]) {
  return attributes.map((a) => getDatasheetProductAttribute(product, a))
}

export function getDatasheetProductAttribute(
  product: MappedProduct,
  attribute: DatasheetProductAttribute
): { label: string; value: string | undefined } {
  switch (attribute) {
    case DATASHEET_PRODUCT_ATTRIBUTES.APPLICATIONS: {
      return {
        label: 'Applications:',
        value: product.attributes.lots?.lot.applications?.application.map((x) => x?.code!).join(', '),
        // value: getApplicationsWithImagesForDatasheets(product)
        //   .map((x) => x?.codeForDisplay!)
        //   .join(', '),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.SPECIES_CROSS_REACTIVITY: {
      return {
        label: 'Species Cross Reactivity:',
        value: product.attributes.lots?.lot.reactivity?.reacts?.map((a) => a.code).join(' '),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.REACTIVITY: {
      return {
        label: 'Reactivity:',
        value: mapSupportingDataAttributeToValue(product, attribute),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.SENSITIVITY: {
      return {
        label: 'Sensitivity:',
        value: mapSupportingDataAttributeToValue(product, attribute),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.OBSERVED_MOLECULAR_WEIGHT: {
      return {
        label: 'MW (kDa):',
        value: mapSupportingDataAttributeToValue(product, attribute),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.ISOTYPE: {
      return {
        label: 'Source/Isotype:',
        value: mapSupportingDataAttributeToValue(product, attribute),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.UNI_PROT_ID: {
      return {
        label: 'UniProt ID:',
        value: product.attributes.targetUniprotList?.map((id) => '#' + id).join(', '),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.ENTREZ_GENE_ID: {
      return {
        label: 'Entrez-Gene Id:',
        value: product.attributes.targetEntrezList?.join(', '),
      }
    }
    case DATASHEET_PRODUCT_ATTRIBUTES.ENTREZ_GENE_ID_HASHTAG: {
      return {
        label: 'Entrez-Gene Id:',
        value: product.attributes.targetEntrezList?.map((id) => '#' + id).join(', '),
      }
    }
  }
}
